const EscapeToCancelMixin = {
  mounted() {
    this._handleEscape = e => {
      if (e.keyCode == 27) {
        if (typeof this.cancel === 'function') {
          e.preventDefault()
          this.cancel()
        } else {
          console.error('cancel method not defined for escape to cancel mixin')
        }
      }
    }
    window.addEventListener('keydown', this._handleEscape)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this._handleEscape)
  },
}

export default EscapeToCancelMixin
